<div class="basic-wrapper">

    <button class="btn lang-btn" (click)="changeLanguage()">
        {{ 'general.language' | translate }}
        <img src="/assets/images/login/english-lang.svg" alt="" *ngIf="language == 'ar'">
        <img src="/assets/images/login/arabic-lang.svg" alt="" *ngIf="language == 'en'">
    </button>
    <router-outlet />
</div>